export default __webpack_public_path__ + "static/media/WAS0333.34I-41669_-24938_0.53753de4.jpg";